export default "__VITE_ASSET__Bz9KnoLM__"